import { a as e, c as t, d as n, f as r, g as i, h as a, i as o, l as s, m as c, n as l, o as u, p as d, r as f, s as p, t as m, u as h } from "./_plugin-vue_export-helper-CsYjOJ0s.js";
import { computed as g, createBlock as _, createCommentVNode as v, createElementBlock as y, createElementVNode as b, createSlots as x, createTextVNode as S, createVNode as C, defineAsyncComponent as w, defineComponent as T, mergeModels as E, mergeProps as D, normalizeClass as O, onBeforeMount as k, onMounted as A, openBlock as j, ref as M, toDisplayString as N, unref as P, useModel as F, watch as I, withCtx as L } from "vue";
import { QBtn as R, QChip as z, QDialog as B, QIcon as V, QInput as H, QSelect as U } from "quasar";
import { BfBrandIcon as W, CMSNotification as G, SEARCH_DEBOUNCE as K, useCardDragSort as q, useNotificationStore as J } from "@editor/ui-utils";
import { useI18n as Y } from "vue-i18n";
//#region src/selectors/channel-list.selector.vue?vue&type=script&setup=true&lang.ts
var ee = { class: "q-icon" }, te = /* @__PURE__ */ m(/* @__PURE__ */ T({
	__name: "channel-list.selector",
	props: {
		modelValue: { default: "" },
		label: { default: void 0 },
		disabled: {
			type: Boolean,
			default: !1
		},
		required: {
			type: Boolean,
			default: !1
		},
		brand: { default: void 0 },
		disableBrand: { type: Boolean },
		isBrandPrefilled: {
			type: Boolean,
			default: !1
		},
		isHomepageChannelHidden: {
			type: Boolean,
			default: !1
		},
		disableClear: {
			type: Boolean,
			default: !1
		},
		dataQa: { default: "data-qa-channel-parent-input-field" }
	},
	emits: [
		"update:modelValue",
		"update:brand",
		"update:channel"
	],
	setup(e, { expose: n, emit: r }) {
		let i = w(() => import("./channel-list-DqoQ-51M.js")), { t: a } = Y(), o = e, c = r, l = M(!1), u = M({ brand: "" }), d = (e) => {
			u.value = e || {
				brand: "",
				title: ""
			}, c("update:modelValue", e?._id), c("update:brand", e?.brand || ""), c("update:channel", e), l.value = !1;
		}, f = g(() => o.label ? o.label : a("components.channelSelectorLabel")), p = g(() => t(u.value.breadcrumb, u.value.title)), m = () => {
			u.value = {
				brand: "",
				title: "",
				_id: void 0
			}, c("update:modelValue", u.value._id), c("update:brand", ""), c("update:channel");
		};
		return n({ resetChannelData: async () => {
			u.value = await s(o.modelValue);
		} }), I(() => o.modelValue, async () => {
			o.modelValue ? (u.value = await s(o.modelValue), c("update:brand", u.value.brand)) : m();
		}, { deep: !0 }), k(async () => {
			o.modelValue && (u.value = await s(o.modelValue));
		}), (t, n) => (j(), y("div", null, [C(P(H), D({
			modelValue: p.value,
			"onUpdate:modelValue": n[0] ||= (e) => p.value = e,
			[e.dataQa || ""]: !0,
			class: e.required && "required",
			disabled: e.disabled,
			label: f.value,
			"background-color": "white",
			clearable: !e.disableClear,
			outlined: "",
			dense: "",
			readonly: ""
		}, t.$attrs, {
			onClick: n[1] ||= (e) => l.value = !0,
			"onClick:clear": n[2] ||= (e) => d(void 0),
			"onClick:append": n[3] ||= (e) => l.value = !0
		}), x({
			append: L(() => [!u.value.title || e.disableClear ? (j(), _(P(V), {
				key: 0,
				name: "external-link"
			})) : (j(), _(P(V), {
				key: 1,
				name: "clear",
				"data-qa-channel-clear": "",
				onClick: m
			}))]),
			_: 2
		}, [u.value.brand ? {
			name: "prepend",
			fn: L(() => [b("span", ee, [C(P(W), { brand: u.value.brand }, null, 8, ["brand"])])]),
			key: "0"
		} : void 0]), 1040, [
			"modelValue",
			"class",
			"disabled",
			"label",
			"clearable"
		]), C(P(B), {
			modelValue: l.value,
			"onUpdate:modelValue": n[6] ||= (e) => l.value = e,
			"allow-focus-outside": "",
			"data-qa-channel-modal": "",
			"full-width": "",
			"full-height": "",
			onHide: n[7] ||= (e) => l.value = !1
		}, {
			default: L(() => [C(P(i), {
				brand: e.brand,
				dialog: !0,
				"filter-id": u.value._id,
				"show-new-button": !1,
				"disable-brand": e.disableBrand,
				"is-brand-prefilled": e.isBrandPrefilled,
				"is-homepage-channel-hidden": e.isHomepageChannelHidden,
				onClose: n[4] ||= (e) => l.value = !1,
				"onClick:channel": d,
				"onBack:modal": n[5] ||= (e) => l.value = !1
			}, null, 8, [
				"brand",
				"filter-id",
				"disable-brand",
				"is-brand-prefilled",
				"is-homepage-channel-hidden"
			])]),
			_: 1
		}, 8, ["modelValue"])]));
	}
}), [["__scopeId", "data-v-9fe87250"]]), X;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.FITFORFUN = "fitforfun", e.FINANZEN100 = "finanzen100", e.MITTIER = "mittier", e.MITSTERNEN = "mitsternen", e.MITBEZIEHUNG = "mitbeziehung", e.TVTODAY = "tvtoday", e.TVSPIELFILM = "tvspielfilm";
})(X ||= {}), Object.freeze(X);
var Z;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.PRAXISTIPPS = "praxistipps";
})(Z ||= {}), Object.freeze(Z), Object.freeze([
	X.MITTIER,
	X.MITSTERNEN,
	X.MITBEZIEHUNG,
	X.TVTODAY,
	X.TVSPIELFILM
]), Object.freeze({
	[X.BUNTE]: "bunte",
	[X.CHIP]: "chip",
	[X.FOCUS]: "focus",
	[X.FITFORFUN]: "fitforfun",
	[X.FINANZEN100]: "finanzen100",
	[X.MITTIER]: "default-verticals",
	[X.MITSTERNEN]: "default-verticals",
	[X.MITBEZIEHUNG]: "default-verticals",
	[X.TVTODAY]: "default",
	[X.TVSPIELFILM]: "default"
});
var Q = Object.freeze(Object.values(X));
Object.freeze(Object.values(Z)), X.BUNTE, X.CHIP, X.FOCUS, X.FITFORFUN, X.TVSPIELFILM, X.TVTODAY, X.BUNTE, X.CHIP, X.FOCUS, X.FITFORFUN, X.TVSPIELFILM, X.TVTODAY;
//#endregion
//#region src/selectors/channel-selector.vue?vue&type=script&setup=true&lang.ts
var $ = 50, ne = /* @__PURE__ */ T({
	__name: "channel-selector",
	props: {
		search: {},
		brand: {},
		modelValue: {},
		mainChannel: {},
		isHomepageChannelHidden: { type: Boolean }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let { t: n } = Y(), r = t, i = e, a = J(), o = M([]), c = M(), l = M(1), u = M(!0), d = M(""), f = g(() => i.mainChannel ? o.value.filter((e) => e._id !== i.mainChannel).map((e) => {
			let t = e.breadcrumb;
			return (e.breadcrumbLength ?? 0) > 1 && (t = e.breadcrumb?.slice(1)), {
				label: t?.map((e) => e.title).join(" > ") || "",
				value: e._id
			};
		}) : []), p = (e) => {
			e.length < $ ? u.value = !1 : u.value = !0;
		}, m = (e, t = 1) => ({
			searchfields: ["title"],
			brand: e,
			isEnabled: !0,
			sortBy: "breadcrumbLength",
			size: $,
			page: t,
			isRootChannel: i.isHomepageChannelHidden ? !1 : void 0
		}), v = async (e) => {
			let t = o.value.find((t) => t._id === e);
			if (!t) try {
				let t = await s(e);
				o.value.push(t);
			} catch {
				a.showNotification(new G(n("channels.errorFailedLoadChannel", { id: e })));
			}
			return t ? t.title : "";
		}, y = (e, t) => {
			t(async () => {
				l.value = 1;
				let { list: t } = await h(e, m(i.brand));
				p(t), o.value = t;
			});
		}, b = () => {
			c.value?.updateInputValue("");
		}, x = (e, t) => {
			t(), b();
		}, w = g({
			get() {
				return i.modelValue ?? [];
			},
			set(e = []) {
				r("update:modelValue", e.map((e) => typeof e == "object" ? e.value : e) ?? []);
			}
		}), T = async ({ to: e, index: t }) => {
			if (e === t && u.value) {
				l.value += 1;
				let { list: e } = await h(d.value, m(i.brand, l.value));
				p(e), o.value.push(...e);
			}
		};
		return I([() => i.brand, () => i.mainChannel], async ([e, t], [n]) => {
			l.value = 1;
			let { list: a } = await h(i.search, m(e));
			p(a);
			let s = n === void 0 && e === void 0, c = n && e && [...Q].includes(e) && n !== e, u = n === void 0 && e && [...Q].includes(e);
			s || c ? (r("update:modelValue", []), o.value = a) : u || (r("update:modelValue", (i.modelValue ?? []).filter((e) => e !== t)), o.value = a);
		}), A(async () => {
			if (i.brand) {
				l.value = 1;
				let { list: e } = await h(i.search, m(i.brand));
				p(e), o.value = e;
			}
		}), (e, t) => (j(), _(P(U), {
			ref_key: "channelMultiSelect",
			ref: c,
			modelValue: w.value,
			"onUpdate:modelValue": t[0] ||= (e) => w.value = e,
			outlined: "",
			dense: "",
			label: P(n)("channels.secondaryChannels"),
			options: f.value,
			"new-value-mode": "add-unique",
			"data-qa-channel-secondary-selector": "",
			"use-input": "",
			multiple: "",
			"map-options": "",
			"input-debounce": P(K),
			"dropdown-icon": "expand_more",
			onFilter: y,
			onAdd: b,
			onNewValue: x,
			onInputValue: t[1] ||= (e) => d.value = e,
			onVirtualScroll: T
		}, {
			"selected-item": L((e) => [C(P(z), {
				"data-qa-secondary-channel-chip": e.index,
				removable: "",
				dense: "",
				color: "cyan-1",
				tabindex: e.tabindex,
				"text-color": "dark",
				onRemove: (t) => e.removeAtIndex(e.index)
			}, {
				default: L(() => [S(N(e.opt.label && e.opt.label.split(" > ").pop() || v(e.opt)), 1)]),
				_: 2
			}, 1032, [
				"data-qa-secondary-channel-chip",
				"tabindex",
				"onRemove"
			])]),
			_: 1
		}, 8, [
			"modelValue",
			"label",
			"options",
			"input-debounce"
		]));
	}
}), re = { class: "q-icon" }, ie = {
	key: 0,
	class: "drop-indicator"
}, ae = {
	key: 1,
	class: "drop-indicator"
}, oe = { class: "dialog-footer q-pa-md" }, se = { class: "col" }, ce = /* @__PURE__ */ m(/* @__PURE__ */ T({
	inheritAttrs: !1,
	__name: "multiple-channel-list-selector",
	props: /* @__PURE__ */ E({
		label: {},
		brand: {},
		maxSelection: {},
		disable: { type: Boolean },
		excludedPrimaryChannel: {},
		sortable: { type: Boolean },
		rules: {}
	}, {
		modelValue: { default: () => [] },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = w(() => import("./channel-list-DqoQ-51M.js")), { t: n } = Y(), r = e, i = F(e, "modelValue"), a = M(!1), o = M([]), { dragOverId: s, insertBefore: c, onDragStart: l, onDragOver: u, onDragLeave: d, onDrop: f, onDragEnd: p } = q(i), m = (e) => ({
			draggable: !r.disable,
			onDragstart: () => l(e),
			onDragover: (t) => u(t, e),
			onDragleave: d,
			onDrop: () => f(e),
			onDragend: p
		}), g = (e) => {
			o.value.find((t) => t._id === e._id) ? o.value = o.value.filter((t) => t._id !== e._id) : o.value.push(e), r.maxSelection && o.value.length > r.maxSelection && (o.value = o.value.slice(r.maxSelection * -1));
		}, T = () => {
			i.value = [...o.value.map((e) => e._id)], a.value = !1;
		}, E = () => {
			o.value = [], a.value = !1;
		}, A = (e) => {
			i.value = i.value.filter((t) => t !== e);
		}, H = async () => {
			if (!i.value.length) {
				o.value = [];
				return;
			}
			try {
				let { list: e } = await h(void 0, { uuids: i.value });
				o.value = e;
			} catch (e) {
				console.error(e);
			}
		};
		return I(() => a.value, async (e) => {
			e && await H();
		}), I(() => i.value, async () => {
			await H();
		}, { immediate: !0 }), k(H), (r, l) => (j(), y("div", D({ class: "red-color" }, r.$attrs), [C(P(U), {
			modelValue: i.value,
			"onUpdate:modelValue": l[0] ||= (e) => i.value = e,
			label: e.label,
			outlined: "",
			dense: "",
			multiple: "",
			chips: "",
			options: o.value,
			disable: e.disable,
			"hide-dropdown-icon": "",
			class: O(["q-field--with-bottom", r.$attrs.class]),
			rules: e.rules,
			"lazy-rules": "ondemand",
			"emit-value": "",
			"use-input": "",
			"map-options": "",
			"option-value": "_id",
			"option-label": "title",
			readonly: "",
			clearable: "",
			"data-qa-multiple-channel-selector-field": "",
			onClick: l[1] ||= (e) => a.value = !0
		}, x({
			"selected-item": L(({ opt: t, toggleOption: n }) => [
				e.sortable && P(s) === (t?._id ?? t) && P(c) ? (j(), y("div", ie)) : v("", !0),
				C(P(z), D({
					color: "cyan-1",
					"text-color": "dark",
					removable: "",
					disable: e.disable
				}, e.sortable ? m(t?._id ?? t) : {}, {
					onRemove: (e) => A(t?._id ?? t),
					onClick: (e) => n(t)
				}), {
					default: L(() => [e.sortable ? (j(), _(P(V), {
						key: 0,
						name: "drag_indicator",
						class: "drag-handle cursor-move q-mr-xs"
					})) : v("", !0), S(" " + N(t.title), 1)]),
					_: 2
				}, 1040, [
					"disable",
					"onRemove",
					"onClick"
				]),
				e.sortable && P(s) === (t?._id ?? t) && !P(c) ? (j(), y("div", ae)) : v("", !0)
			]),
			append: L(() => [C(P(V), { name: "external-link" })]),
			_: 2
		}, [e.brand ? {
			name: "prepend",
			fn: L(() => [b("span", re, [C(P(W), { brand: e.brand }, null, 8, ["brand"])])]),
			key: "0"
		} : void 0]), 1032, [
			"modelValue",
			"label",
			"options",
			"disable",
			"class",
			"rules"
		]), C(P(B), {
			modelValue: a.value,
			"onUpdate:modelValue": l[5] ||= (e) => a.value = e,
			"allow-focus-outside": "",
			"data-qa-channel-modal": "",
			"full-width": "",
			"full-height": "",
			class: "channel-list-selector",
			onHide: E
		}, {
			default: L(() => [C(P(t), {
				"selected-channels": o.value,
				"onUpdate:selectedChannels": l[2] ||= (e) => o.value = e,
				brand: e.brand,
				"show-new-button": !1,
				selection: "multiple",
				dialog: "",
				"disable-brand": "",
				"is-brand-prefilled": "",
				"is-homepage-channel-hidden": "",
				"excluded-primary-channel": e.excludedPrimaryChannel,
				onClose: l[3] ||= (e) => a.value = !1,
				"onClick:channel": g,
				"onBack:modal": l[4] ||= (e) => a.value = !1
			}, {
				footer: L(() => [b("div", oe, [b("div", se, [C(P(R), {
					color: "primary",
					icon: "send",
					class: "q-mr-sm",
					label: P(n)("channels.addSelectedChannels"),
					"data-qa-channels-add-selector-button": "",
					onClick: T
				}, null, 8, ["label"]), C(P(R), {
					"text-color": "secondary",
					icon: "close",
					color: "primary",
					class: "q-mr-sm bg-white",
					label: P(n)("articles.cancelButton"),
					"data-qa-channels-cancel-selector-button": "",
					onClick: E
				}, null, 8, ["label"])])])]),
				_: 1
			}, 8, [
				"selected-channels",
				"brand",
				"excluded-primary-channel"
			])]),
			_: 1
		}, 8, ["modelValue"])], 16));
	}
}), [["__scopeId", "data-v-6d7da91d"]]), le = w(() => import("./channel-list-DqoQ-51M.js")), ue = () => import("./channel-list-DqoQ-51M.js"), de = {
	routes: [],
	messages: {
		en: {},
		de: {}
	}
};
//#endregion
export { le as ChannelList, te as ChannelListSelector, l as ChannelModelName, ne as ChannelSelector, f as ChannelService, ce as MultipleChannelListSelector, de as channelComponentsModule, o as checkChannelArticles, e as checkPathConflict, u as deleteChannel, p as fetchChannelDepth, t as formatBreadcrumb, s as getChannel, ue as getChannelListComponent, h as getChannels, n as getDefaultStateChannel, r as getSubChannels, d as loadMainChannels, c as postChannel, a as putChannel, i as updateLegacyMigration };

//# sourceMappingURL=index.es.js.map